import { render, staticRenderFns } from "./Personals.vue?vue&type=template&id=3a9adca0&scoped=true"
import script from "./Personals.vue?vue&type=script&lang=js"
export * from "./Personals.vue?vue&type=script&lang=js"
import style0 from "./Personals.vue?vue&type=style&index=0&id=3a9adca0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9adca0",
  null
  
)

export default component.exports